<template>
    <div>
        <el-dialog title="选择公司" :visible.sync="dialogVisible" width="800px">
            <div class="filter-bar">
                <label>公司名称</label>
                <el-input v-model="filters.companyName" placeholder="公司名称" style="width: 280px; margin: 0 10px" />
                <el-button @click="search" type="primary" style="width: 110px">搜索</el-button>
                <el-button type="text" @click="createCompany" style="margin: 0 24px">创建公司</el-button>
                <el-button
                    icon="el-icon-refresh"
                    type="text"
                    size="medium"
                    @click="refresh"
                    style="flex-grow: 1; text-align: right; color: rgb(96, 98, 102)"
                >
                    刷新
                </el-button>
            </div>
            <el-table ref="table" :data="companyList" stripe style="width: 100%" @selection-change="handleSelectionChange" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="companyName" label="公司名称" />
                <el-table-column prop="industry" label="行业" />
                <el-table-column label="规模">
                    <template slot-scope="scope">
                        {{ getScaleLabel(scope.row.scale) }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @current-change="handlePageChange"
                :current-page="pagination.pageNum"
                :page-size="pagination.pageSize"
                :total="pagination.total"
                layout="prev, pager, next"
            />
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="confirm">保存</el-button>
            </span>
        </el-dialog>

        <CompanyCreateEditDialog v-model="showCreateDialog" @confirm="onCreateConfirm" />
    </div>
	
</template>

<script>
import { companyRecruit } from "@/services";
import CompanyCreateEditDialog from "@/components/recruit/CompanyCreateEditDialog.vue";

export default {
	name: "CompanySelectDialog",
	components: {
		CompanyCreateEditDialog,
	},
	props: {
		visible: Boolean,
	},
	data() {
		return {
			filters: {
				companyName: "",
			},
			companyList: [],
			pagination: {
				pageNum: 1,
				pageSize: 10,
				total: 0,
			},
			selectedCompanies: [],
			showCreateDialog: false,
			scaleOptions: [
				{ label: "0-20人", value: 0 },
				{ label: "20-99人", value: 1 },
				{ label: "100-499人", value: 2 },
				{ label: "500-999人", value: 3 },
				{ label: "1000-9999人", value: 4 },
				{ label: "10000人以上", value: 5 },
			],
		};
	},
	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit("update:visible", val);
			},
		},
	},
	watch: {
		visible(val) {
			if (val) {
				this.fetchCompanies();
			}
		},
	},
	methods: {
		async fetchCompanies() {
			const params = {
				pageNum: this.pagination.pageNum,
				pageSize: this.pagination.pageSize,
				companyName: this.filters.companyName,
			};
			const {data, ok} = await companyRecruit.pageList(params)
            if(ok) {
                this.companyList = data.data.list || [];
                this.pagination.total = data.data.total || 0;
            }
		},
		search() {
			this.pagination.pageNum = 1;
			this.fetchCompanies();
		},
		createCompany() {
			this.showCreateDialog = true;
		},
		onCreateConfirm() {
			this.search();
		},
		refresh() {
			this.fetchCompanies();
		},
		handleSelectionChange(selection) {
			if (selection.length > 1) {
				this.$refs.table.clearSelection();
				this.$refs.table.toggleRowSelection(selection[selection.length - 1]);
				this.selectedCompanies = [selection[selection.length - 1]];
			} else {
				this.selectedCompanies = selection;
			}
		},
		handleCurrentChange(currentRow, oldCurrentRow) {
			if (currentRow) {
				this.$refs.table.clearSelection();
				this.$refs.table.toggleRowSelection(currentRow);
				this.selectedCompanies = [currentRow];
			}
		},
		handlePageChange(page) {
			this.pagination.pageNum = page;
			this.fetchCompanies();
		},
		cancel() {
			this.dialogVisible = false;
		},
		getScaleLabel(scale) {
			const option = this.scaleOptions.find(opt => opt.value === scale);
			return option ? option.label : scale;
		},
		confirm() {
			if (this.selectedCompanies.length === 0) {
				this.$message.warning("请选择公司");
				return;
			}
			if (this.selectedCompanies.length > 1) {
				this.$message.warning("只能选择一个公司");
				return;
			}
			this.$emit("confirm", this.selectedCompanies[0]);
			this.dialogVisible = false;
		},
	},
};
</script>

<style scoped>
.filter-bar {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
</style>
